// extracted by mini-css-extract-plugin
export default {"Box":"chart-link-module__Box--lPKlO","PotentiallyDirty":"chart-link-module__PotentiallyDirty--Guavb"};